import React, { FC } from 'react';
import { DocType } from '../../../../types';
import DocumentCardLayout from './DocumentCardLayout/DocumentCardLayout';
import { useAppStore } from '../../../../store/appStore';
import { trackAction } from '../../../../libs/analytics/ActionTracking';
import EditDocPopup from '../EditDocPopup/EditDocPopup';

type NewDocCardProps = {
  docType: DocType;
};

export const NewDocCard: FC<NewDocCardProps> = ({ docType }) => {
  const showWindow = useAppStore((state) => state.showWindow);

  function handleUploadButtonClick() {
    trackAction(`Upload new ${docType} click`, null);
    showWindow(<EditDocPopup docType={docType} />);
  }

  return (
    <DocumentCardLayout
      docType={docType}
      button={{ title: 'Upload Document', onClick: handleUploadButtonClick }}
      isNewDocument
    />
  );
};
